import User from '../user/user.model';

export default class ExternalLayer {
    public id = '';
    public url = '';
    public name = '';
    public type = '';
    public index = 0;
    public hidden = 0;
    public createdAt: Date = new Date();
    public createdBy: User = new User();

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.url) {
            this.url = model.url;
        }
        if (model.name) {
            this.name = model.name;
        }
        if (model.type) {
            this.type = model.type;
        }
        if (model.index) {
            this.index = model.index;
        }
        if (model.hidden) {
            this.hidden = model.hidden;
        }
        if (model.createdAt) {
            this.createdAt = new Date(model.createdAt);
        }
        if (model.createdBy) {
            this.createdBy = new User(model.createdBy);
        }
    }
}
